module.exports = __webpack_public_path__ + "img/IMG_6902.c42067d1.webp";